import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Icon } from 'rsuite';
import {
  getCampaignElementById,
  getHasUploadedVideoForQuestionId,
  getIsQuestionPreview,
  getMediaSubmissionIdForElement,
  showFullQuestion,
  updateMediaSubmissionStatus,
} from '../../redux/modules/campaignLandingPage';
import styles from './QuestionPreview.module.less';

const QuestionPreview = ({
  _showFullQuestion,
  _updateMediaSubmissionStatus,
  hasUploadedVideo,
  isPreview,
  mediaSubmissionId,
  question,
  qid,
}) => {
  useEffect(() => {
    // If we've uploaded or recorded a video, notify the backend
    // A successful video upload will close the FullQuestion component
    // and display this one instead
    // so it's the perfect place to run this update
    if (mediaSubmissionId !== null) {
      _updateMediaSubmissionStatus(mediaSubmissionId);
    }
  }, [hasUploadedVideo]);

  if (!isPreview) {
    return null;
  }

  return (
    <>
      <Icon
        className={styles.vpTogglePreview}
        icon="down"
        onClick={() => _showFullQuestion(qid)}
      />
      <section
        className={styles.vpQuestionPreviewHeader}
        data-testid="questionShowToggle"
        onClick={() => _showFullQuestion(qid)}
      >
        <h4 className={styles.vpQuestionPreviewTitle}>
          {question.label}
        </h4>
      </section>
    </>
  );
};

QuestionPreview.propTypes = {
  _showFullQuestion: PropTypes.func,
  _updateMediaSubmissionStatus: PropTypes.func,
  isPreview: PropTypes.bool,
  mediaSubmissionId: PropTypes.string,
  question: PropTypes.object,
  qid: PropTypes.string,
};

function mapStateToProps(state, ownProps) {
  return {
    question: getCampaignElementById(state, ownProps.qid),
    hasUploadedVideo: getHasUploadedVideoForQuestionId(state, ownProps.qid),
    isPreview: getIsQuestionPreview(state, ownProps.qid),
    mediaSubmissionId: getMediaSubmissionIdForElement(state, ownProps.qid),
  };
}

const mapDispatchToProps = {
  _showFullQuestion: showFullQuestion,
  _updateMediaSubmissionStatus: updateMediaSubmissionStatus,
};

export default connect(mapStateToProps, mapDispatchToProps)(QuestionPreview);




// WEBPACK FOOTER //
// ./src/components/CampaignLanding/QuestionPreview.jsx